import { IconRalphWiggum } from "@/assets/icons/IconRalphWiggum";
import { IconChevronDown } from "@/assets/icons/geist/IconChevronDown";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/podkit/dropdown/DropDown";
import { cn } from "@/components/podkit/lib/cn";
import { Check, FileText } from "lucide-react";
import { IconCodeAssistant } from "central-icons/IconCodeAssistant";
import { AgentMode, getAgentModeLabel } from "@/components/ai/prompt-input/agent-mode";

const getModeIcon = (mode: AgentMode, size: number) => {
    switch (mode) {
        case AgentMode.Ralph:
            return <IconRalphWiggum size={size} />;
        case AgentMode.Spec:
            return <FileText size={size} />;
        case AgentMode.Agent:
        default:
            return <IconCodeAssistant size={size} />;
    }
};

const getModeColorClass = (mode: AgentMode): string => {
    switch (mode) {
        case AgentMode.Ralph:
            return "text-content-orange";
        case AgentMode.Spec:
            return "text-content-brand";
        case AgentMode.Agent:
        default:
            return "";
    }
};

export const AgentModeDropdown = ({
    mode,
    onModeChange,
    availableModes,
}: {
    mode: AgentMode;
    onModeChange: (mode: AgentMode) => void;
    availableModes: AgentMode[];
}) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                className={cn(
                    "inline-flex h-8 min-w-24 items-center justify-between gap-1.5 rounded-md border border-border-base bg-transparent px-2 text-sm font-medium text-content-secondary",
                    "hover:bg-surface-hover focus:outline-none focus-visible:ring-0",
                )}
            >
                <div className={cn("flex items-center gap-1.5", getModeColorClass(mode))}>
                    {getModeIcon(mode, 16)}
                    <span>{getAgentModeLabel(mode)}</span>
                </div>
                <IconChevronDown size="sm" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" side="top" className="w-24">
                {availableModes.map((availableMode) => (
                    <DropdownMenuItem
                        key={availableMode}
                        onClick={() => onModeChange(availableMode)}
                        data-tracking-id={`agent-mode-${availableMode}`}
                        className={getModeColorClass(availableMode)}
                    >
                        {getModeIcon(availableMode, 16)}
                        <span className="ml-2">{getAgentModeLabel(availableMode)}</span>
                        {mode === availableMode && <Check size={14} className="ml-auto" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
